import styled from 'styled-components';

export const FilterWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;
